import React from 'react'
import FastSequenceInfo from './FastSequenceInfo'
import FastSequenceProperties from './FastSequenceProperties'
import Specifications from './Specifications'
import { useBitubeTotalValidationMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { biTubeConfigContext } from '../../BiTube'
import SingleProductEntryButtons from '../../SingleProductEntryButtons'
import { useIntl } from 'react-intl'
import messages from '../../../../messages'
import { ConfiguratorValues } from '../../../../utils/constants'
import { BiTubeProduct } from '../../enum'
import MirnaAntisenceStrand from './MirnaAntisenceStrand'

const FastSingleProductEntry = (props) => {
  const intl = useIntl()
  const {
    productDetails,
    setActive,
    setAddItemsFromSideNav,
    setItemDetails,
    specifications,
  } = props
  const [bitubeTotalValidation] = useBitubeTotalValidationMutation()
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const { sessionData, callTotalValidation, currentOligoIndex } = bitubeState
  setAddItemsFromSideNav(false)
  const setErrorData = (index) => {
    return {
      name: sessionData[index].name,
      sequence: sessionData[index].sequence,
      scale: '',
      purification: sessionData[index].purification,
      fiveMod: '',
      threeMod: sessionData[index].threeMod,
      researcher: '',
      isOverridden: sessionData[index].isOverridden,
      format: sessionData[index].format,
      concentration: sessionData[index].concentration,
      tubes: sessionData[index].tubes,
      customerOverhang: sessionData[index].customerOverhang,
      antisenceName: sessionData[index].antisenceName,
      antisenceSequence: sessionData[index].antisenceSequence,
      customerAntisenseOverHang: sessionData[index].customerAntisenseOverHang,
      antisenceThreeMod: sessionData[index].antisenceThreeMod,
      antisenceFiveMod: sessionData[index].antisenceFiveMod,
      antisenceBaseCount: 0,
      amount: sessionData[index].amount,
      autoGenerateOligo: sessionData[index].autoGenerateOligo,
      senseNameCheck: sessionData[index].senseNameCheck,
    }
  }
  const totalValidation = async (addNew) => {
    const response: any = await bitubeTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    if (response.data && response.data.bitubeTotalValidation.length) {
      if (!response.data.bitubeTotalValidation[0].serverError) {
        let flag = false
        response.data.bitubeTotalValidation.forEach((item, index) => {
          const error: any[] = []
          item.listErrors.forEach((err) => {
            delete err.__typename
            error.push(err)
          })
          if (sessionData.length > index) {
            sessionData[index].listError = error
          }
          if (item.listErrors.length !== 0) {
            if (!flag && addNew) {
              biTubeDispatch({
                type: 'UPDATE_CURRENT_OLIGO_INDEX',
                data: index,
              })
              biTubeDispatch({
                type: 'UPDATE_ERROR_DATA',
                data: setErrorData(index),
              })
            }
            flag = true
            biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
          }
        })
        if (!flag) {
          if (
            response.data.bitubeTotalValidation[currentOligoIndex].listErrors
              .length === 0
          ) {
            biTubeDispatch({ type: 'HAS_REVIEW_ERROR', data: false })
            biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
            biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
            if (addNew) {
              biTubeDispatch({
                type: 'ADD_NEW_OLIGO',
                data: bitubeState.oligoCount + 1,
              })
            }
          }
        } else {
          if (addNew) {
            //if called from add item
            biTubeDispatch({
              type: 'SET_PAGE_ERROR',
              data: intl.formatMessage(messages.CONF_OLIGO_ERROR_POPUP_MSG),
            })
            window.scrollTo(0, 0)
          }
          biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 1 })
        }
        biTubeDispatch({ type: 'CALL_TOTAL_VALIDATION', data: false })
        biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: true })
        biTubeDispatch({
          type: 'ITEM_VALIDATION',
          data: false,
        })
        biTubeDispatch({
          type: 'UPDATE_TOTALVALIDATION',
          data: response.data.bitubeTotalValidation,
        })
      } else {
        biTubeDispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  React.useEffect(() => {
    //STRAT-17359 Start
    if (bitubeState.isPageLoad === 0) {
      biTubeDispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
    }
    //STRAT-17359 End
    return function cleanupError() {
      biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
      biTubeDispatch({ type: 'ADD_NEW_DUPLEX', data: false })
      biTubeDispatch({ type: 'IS_COMING_FROM_CONFIGM_PAGE', data: false })
      if (
        sessionData &&
        sessionData[currentOligoIndex] &&
        sessionData[currentOligoIndex].name === '' &&
        sessionData[currentOligoIndex].sequence === '' &&
        sessionData[currentOligoIndex].antisenceName === '' &&
        sessionData[currentOligoIndex].antisenceSequence === ''
      ) {
        biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
        biTubeDispatch({ type: 'SET_ERROR_ON_PAGE_REFRESH', data: false })
        biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
        biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
        sessionData[currentOligoIndex].listError = []
      } else {
        biTubeDispatch({ type: 'SET_ERROR_ICON_ON_PAGELOAD', data: false })
        biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
        biTubeDispatch({ type: 'SET_ERROR_ON_PAGE_REFRESH', data: true })
        biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
        if (
          sessionData &&
          sessionData[currentOligoIndex] &&
          sessionData[currentOligoIndex].amount === '' &&
          sessionData[currentOligoIndex].purification === '' &&
          sessionData[currentOligoIndex].format === ''
        ) {
          biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: true })
        } else {
          biTubeDispatch({
            type: 'SPECIFICATION_TOTAL_VALIDATION',
            data: false,
          })
        }
      }
    }
  }, [])
  React.useEffect(() => {
    if (callTotalValidation) {
      totalValidation(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [callTotalValidation])

  React.useEffect(() => {
    if (bitubeState.itemValidation) {
      totalValidation(false)
    }
    // TODO: need a test before we refactor these dependencies
  }, [bitubeState.itemValidation])
  return (
    <>
      {productDetails.productType === BiTubeProduct.mirna ? (
        <MirnaAntisenceStrand
          productDetails={productDetails}
          specifications={specifications}
        />
      ) : (
        <FastSequenceInfo
          productDetails={productDetails}
          specifications={specifications}
        />
      )}
      <FastSequenceProperties productDetails={productDetails} />
      <Specifications
        productDetails={productDetails}
        specificationsData={specifications}
      />
      <SingleProductEntryButtons
        productDetails={productDetails}
        setActive={setActive}
        setItemDetails={setItemDetails}
      />
    </>
  )
}

export default FastSingleProductEntry
